import {CanActivateFn, Router} from '@angular/router';
import {inject} from '@angular/core';
import {AuthService} from '../../features/auth/services/auth.service';
import {map, catchError, of} from 'rxjs';
import { SnackbarService } from '@/app/shared/services/snackbar.service';

export const AuthGuard: CanActivateFn = () => {
  const snackbarService = inject(SnackbarService)
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isAuthenticated()) {
    return true;
  }

  // If not authenticated, try to refresh token
  return authService.checkAndRefreshToken().pipe(
    map(() => {
      if (authService.isAuthenticated()) {
        return true;
      } else {
        router.navigate(['/iniciar']);
        snackbarService.showInfo('Su sesión ha expirado. Por favor, vuelva a iniciar sesión.');
        return false;
      }
    }),
    catchError(() => {
      router.navigate(['/iniciar']);
      snackbarService.showInfo('Su sesión ha expirado. Por favor, vuelva a iniciar sesión');
      return of(false);
    })
  );
}
